import { useEffect, useState } from 'react';
import { Info, AlertTriangle, CheckCircle2, X } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const DISMISS_KEY = 'ibclub_ann_dismissed';

const LEVELS = {
  info: { bg: 'bg-blue-500/10 border-blue-500/30 text-blue-200', icon: Info },
  success: { bg: 'bg-green-500/10 border-green-500/30 text-green-200', icon: CheckCircle2 },
  warning: { bg: 'bg-amber-500/10 border-amber-500/30 text-amber-200', icon: AlertTriangle },
};

const AnnouncementBanner = () => {
  const [ann, setAnn] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/announcement`);
        if (r.data?.active && r.data?.message) {
          const stored = localStorage.getItem(DISMISS_KEY);
          if (stored !== r.data.message) {
            setAnn(r.data);
          }
        }
      } catch { /* ignore */ }
    })();
  }, []);

  if (!ann || dismissed) return null;
  const cfg = LEVELS[ann.level] || LEVELS.info;
  const Icon = cfg.icon;

  return (
    <div
      data-testid="announcement-banner"
      className={`fixed top-0 left-0 right-0 z-[60] border-b ${cfg.bg} backdrop-blur-md px-4 py-2.5 flex items-center justify-center gap-3 text-sm`}
    >
      <Icon size={16} className="shrink-0" />
      <span className="text-center">{ann.message}</span>
      <button
        onClick={() => {
          localStorage.setItem(DISMISS_KEY, ann.message);
          setDismissed(true);
        }}
        aria-label="Dismiss"
        data-testid="announcement-dismiss"
        className="ml-2 opacity-70 hover:opacity-100"
      >
        <X size={14} />
      </button>
    </div>
  );
};

export default AnnouncementBanner;
